import experiment from 'experiment';
import { biLogger } from '#packages/util';
import type { EditorAPI } from '#packages/editorAPI';
import { topBarSavePopOverClickSrc38Evid1617 } from '@wix/bi-logger-editor-data/v2';

export const reportTopBarViewSiteHistoryClick = () => {
  biLogger.report(
    topBarSavePopOverClickSrc38Evid1617({
      ts: Date.now(),
    }),
  );
};

export const onViewSiteHistoryClick = (editorAPI: EditorAPI) => {
  if (experiment.isOpen('se_bypassSiteHistoryModal')) {
    editorAPI.account.openSiteHistory();

    return;
  }

  editorAPI.account.openRevisions();
};
